import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import {ScreenDoor} from './ScreenDoor'
import {CloseX} from './CloseX'
import {BulletLine} from './BulletLine'
import * as Request from '../tgccRequest'
import Radium, { StyleRoot } from 'radium'


const boxStyle: React.CSSProperties = {
    height: '240px',
    width: '380px',
    position: 'absolute',
    top: '50%',
    marginTop: '-120px',
    left: '50%',
    marginLeft: '-190px',
    padding: '20px',
    backgroundColor: 'white',
    fontFamily: 'CenturyGothic',
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    '@media (max-width:414px)': {
        width:'322px',
        left: '57%',
    },
    '@media (max-width:375px)': {
        width:'300px',
        marginLeft:'-172px'
    },
    '@media (max-width:320px)': {
        width:'270px',
        marginLeft:'-155px'
    }
};

const rowStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
    height: '30px',
    alignItems: 'center'
}

const lblStyle: React.CSSProperties = {
    color: Tgcc.Styles.darkTextColor,
    height: '25px',
    lineHeight: '25px',
    fontSize: '18px',
    marginRight: '8px',
    flexGrow: 0,
    '@media (max-width:320px)': {
        marginRight:'25px'
    }
}
let infoStyle = Object.assign({}, lblStyle, {height: 'auto', marginBottom: '10px', fontSize: '14px', textAlign: 'center'})

const inputStyle: React.CSSProperties = {
    backgroundColor: Tgcc.Styles.inputBackground,
    border: 'none',
    height: '25px',
    lineHeight: '25px',
    padding: '0 4px',
    fontSize: '16px',
    flexGrow: 1
}

let fadedButtonStyle = Object.assign( {}, Tgcc.Styles.grayButton, { opacity: 0.5});

class Props extends Tgcc.BaseProps{
    email: string;
}

class _ForgotPassword extends React.Component<Props, any> {
    state: any = {
        email: "",
        isWaiting: false
    };

    componentWillMount(){
        this.setState({email: this.props.email});
    }
    
    cancel = () => {
        this.setState({isWaiting: false});
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: null})
    }

    onSuccess = () => {
        var msg="An email has been dispatched with instructions for creating a new password for your account. The reset link will expire in 24 hours.";
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: {action: Tgcc.DialogAction.MessagePopup, payload: {title: "Password Reset", message: msg}}})
    }
    failedReset = (err: any) => {
        this.setState({isWaiting: false, error: err});
    }

    doReset = () => {
        if(!Tgcc.IsValidEmail(this.state.email)){
            this.setState({error: 'Please enter a valid email address', isWaiting: false});
        }else {
           this.setState({isWaiting: true});
           Request.passwordResetRequest(this.state.email, this.onSuccess, this.failedReset)
        }
    }

    emailChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({email: evt.currentTarget.value});
    }

    emailIsValid = () => {
        return Tgcc.IsValidEmail(this.state.email);
    }

    keyPressed = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if(evt.key === 'Enter')
            this.doReset();
    }

    render(){
        var btnElement = this.state.isWaiting ? 
            Tgcc.workingGif
            : <div className="grayButton" style={Tgcc.Styles.grayButton} onClick={this.doReset}>Submit</div>
        btnElement = this.emailIsValid() ? btnElement : <div style={fadedButtonStyle}>Submit</div>

        var errElement = this.state.error ? <div style={Tgcc.Styles.error}>{this.state.error}</div> : <div/>
        return(
            <ScreenDoor>
                <div style={boxStyle}>
                    <BulletLine text="Forgot password" fontSize="14px" bulletSize="5px" />
                    <CloseX closeAction={this.cancel} />
                    {errElement}
                    <div style={rowStyle}>
                        <div style={infoStyle}>Submit your email address to receive a password reset link.</div>
                    </div>
                    <div style={rowStyle}>
                        <div style={lblStyle}>Email</div>
                        <input autoFocus type='text' style={inputStyle} name='email' onChange={this.emailChanged} onKeyPress={this.keyPressed} value={this.state.email}/>
                    </div>
                    {btnElement}
                </div>
            </ScreenDoor>
        );
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export var ForgotPassword = connect(mapStateToProps)(Radium(_ForgotPassword));